import React from 'react';

import { IconButton, SpeakerNotesOffIcon, ChatIcon } from '@gogame/components';

import Annotations from './Annotations';
import useTrigger from './useTrigger';

export * from './constants';
export { annotationsSchema } from './schema';

let lastAnnotationUniqueId = 0;

export const getAnnotationUniqueId = () => {
  lastAnnotationUniqueId += 1;
  return lastAnnotationUniqueId;
};

export const AnnotationsKnob = ({ id, showAnnotations, disabled }) => {
  const { Knob, State } = useTrigger(id);
  return (
    <Knob isOpen={showAnnotations}>
      {(triggerContext) => (
        <React.Fragment>
          <IconButton
            icon={showAnnotations ? <SpeakerNotesOffIcon /> : <ChatIcon />}
            onClick={triggerContext.toggle}
            disabled={disabled}
            // data-cy={'showAnnotationsButton'}
            tooltip={
              showAnnotations ? 'Turn off annotations' : 'Turn on annotations'
            }
          />
          <State isOpen={showAnnotations} />
        </React.Fragment>
      )}
    </Knob>
  );
};

export const AnnotationsContent = ({ id, onHide, ...props }) => {
  const { Content, State } = useTrigger(id);

  return (
    <Content>
      {(trigger) => {
        return (
          <React.Fragment>
            <Annotations {...props} onClose={trigger.close} />
            <State onClose={onHide} />
          </React.Fragment>
        );
      }}
    </Content>
  );
};
